export const getExcelDownload = (base64Data, fileName) => {
  // Base64 디코딩
  const byteCharacters = atob(base64Data)
  const byteNumbers = new Array(byteCharacters.length)
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i)
  }
  const byteArray = new Uint8Array(byteNumbers)

  // blob 생성
  const blob = new Blob([byteArray], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  // a 태그를 사용하여 다운로드 링크 생성
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = `${fileName}.xlsx`

  // 생성
  document.body.appendChild(link)

  // 다운로드
  link.click()

  // 제거
  document.body.removeChild(link)
}
